import { createRoot } from "react-dom/client";
import "./styles/index.css";
import React from 'react';
import RoutedApp from "./RoutedApp";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <RoutedApp />
);


// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
